import apiClient from 'api/config/apiClient'

export default {
  getEmployeeCards(payload) {
    return apiClient.request('employee_cards', payload)
  },
}
